import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import React, { memo, useEffect, useState } from 'react';

import Content from 'src/components/task/surgeryCalendar/surgerySchedule/contentSchedule/Content';

import { useStore } from 'src/context/StoreContext';

type ContentScheduleProps = {
  doctors: any;
  reserves: any[];
  handleOpenDetail: (reservation_id: string) => void;
  fields: any;
};

const ContentSchedule: React.FC<ContentScheduleProps> = (props) => {
  const storeContext = useStore();
  const optionFilterSelected = storeContext.optionFilterSelected;
  const [page, setPage] = useState<number>(1);
  const [viewFull, setViewFull] = useState<boolean>(false);

  const changePrevPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const changeNextPage = () => {
    if (page < props.reserves.length) {
      setPage(page + 1);
    }
  };

  const changeView = () => {
    setViewFull(!viewFull);
  };

  useEffect(() => {
    if (optionFilterSelected.length !== 0) {
      setPage(1);
    }

    // eslint-disable-next-line
  }, [optionFilterSelected]);

  return (
    <Box>
      {props.reserves.map(
        (reserve: any, index: number) =>
          index === page - 1 && (
            <Box key={index + '-' + reserve.id} px={'8px'}>
              <Content
                doctor={props.doctors[reserve['doctor_id']]}
                handleOpenDetail={props.handleOpenDetail}
                viewFull={viewFull}
                dataContent={reserve}
                onChangeViewFull={changeView}
                fields={props.fields}
              />
            </Box>
          )
      )}

      {props.reserves.length !== 0 && (
        <Stack direction={'row'} justifyContent={'space-between'} px={'8px'}>
          <IconButton
            onClick={changePrevPage}
            sx={{ p: '0px' }}
            title='Previous page'
            disabled={page <= 1}
          >
            <Box
              component={'img'}
              src='/images/icons/ic-arrow-left.svg'
              sx={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
          </IconButton>

          <Typography
            sx={{
              fontWeight: '400',
              lineHeight: '12px',
              fontSize: '12px',
              alignContent: 'center',
            }}
            component='label'
          >{`${page}/${props.reserves.length}`}</Typography>

          <IconButton
            onClick={changeNextPage}
            sx={{ p: '0px' }}
            title='Next page'
            disabled={page >= props.reserves.length}
          >
            <Box
              component={'img'}
              src='/images/icons/ic-arrow-right.svg'
              sx={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
          </IconButton>
        </Stack>
      )}
    </Box>
  );
};

export default memo(ContentSchedule);
